export const NAME = 'featureFlag';
